/**
 * ChatLauncher component
 * Figma: https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?node-id=4359%3A69046&mode=dev
 */
import { Button } from '@legalzoom/ui/negroni';
import { openChatMessenger } from '../methods/client';
import { HelpIcon } from '@legalzoom/ui/icons';

export function MiniChatLauncher() {
  function handleClick() {
    openChatMessenger();
  }

  return (
    <Button
      icon={HelpIcon}
      variant="ghost"
      tooltip="Help"
      size="lg"
      onPress={() => handleClick()}
      color="neutral"
      className="size-8"
      aria-label="Help"
    />
  );
}
